import React from "react";

function PFDateAndDesc({...props}) {
    return (
        <div>
            <p>
                Winchester Porchfest 2025 will be held on <strong>Saturday June 14 from 12-5:30pm</strong>
                <br/>
                (&#x1F4A7; Rain date: Sunday June 15 from 12-5:30pm)
            </p>
            <p>
                Finale concert performance by Diver9 at The Griffin Museum Terrace (67 Shore Rd) from 6:00p to 7:30p
            </p>
        </div>
    );
}

export default PFDateAndDesc;